export const cartObject = /* GraphQL */ `
cart {
  id
  checkoutUrl
  cost {
    subtotalAmount {
      amount
      currencyCode
    }
    totalAmount {
      amount
      currencyCode
    }
  }
  discountCodes {
    applicable
    code
  }
  lines(first: 10) {
    nodes {
      id
      quantity
      cost {
        totalAmount {
          amount
          currencyCode
        }
        subtotalAmount {
          amount
          currencyCode
        }
      }
      merchandise {
        ... on ProductVariant {
          id
          title
          priceV2 {
            amount
            currencyCode
          }
          product {
            id
            title
            handle
            vendor
            images(first: 1) {
              nodes {
                id
                originalSrc
                altText
              }
            }
          }
        }
      }
    }
  }
}
`;
